import React, { useState } from 'react';

import PropTypes from 'prop-types';

import amplitude from 'amplitude-js';
import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';
import { BANK_ACCOUNT_CANCELED_TRANSFER_BUTTON_CLICKED } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { AUTH, AUTH_PAYMENTS_HISTORY } from 'apps/auth/constants/UrlConstants';
import { fetchData } from 'apps/auth/helpers/api';
import { useCheck, useChequeExtra, usePageMessages } from 'apps/auth/hooks/selectors';

import CancelOperationPopup from './CancelOperationPopup';

const PayOrCanselPopup = (props) => {
    const { payCancelButton, payWithBankAccountButton, iDidNotPayYetButton, iPaidButton, cancellationPaidDescription } = usePageMessages();
    const { paymentId } = useCheck();
    const { i_paid } = useChequeExtra();

    const [askAboutPaid, setAskAboutPaid] = useState(i_paid === '1');

    const getButtons = (aboutPaid) => {
        if (aboutPaid) {
            return (
                <>
                    <PopupButton
                        iconName="cross"
                        text={iDidNotPayYetButton}
                        onClick={(e) => {
                            e.preventDefault();
                            fetchData(`${AUTH}/payments/${paymentId}/iPaid?isPaid=false`, 'POST', undefined, true);
                            setAskAboutPaid(false);
                        }}
                    />
                    <PopupButton
                        iconName="check"
                        text={iPaidButton}
                        onClick={(e) => {
                            e.preventDefault();
                            fetchData(`${AUTH}/payments/${paymentId}/iPaid?isPaid=true`, 'POST', undefined, true);
                            props.popupRef.current?.open(<CancelOperationPopup popupRef={props.popupRef} cancelAction={props.cancelAction} />);
                        }}
                    />
                </>
            );
        } else {
            return (
                <>
                    <PopupButton iconName="bank" href={`${AUTH_PAYMENTS_HISTORY}?paymentId=${paymentId}`} text={payWithBankAccountButton} />
                    <PopupButton
                        iconName="cross"
                        text={payCancelButton}
                        onClick={(e) => {
                            e.preventDefault();
                            amplitude.getInstance().logEvent(BANK_ACCOUNT_CANCELED_TRANSFER_BUTTON_CLICKED);
                            props.cancelAction();
                        }}
                    />
                </>
            );
        }
    };

    return (
        <SimplePopup popupRef={props.popupRef} text={askAboutPaid ? cancellationPaidDescription : null} withoutCloseButton withoutBorder={!askAboutPaid}>
            {getButtons(askAboutPaid)}
        </SimplePopup>
    );
};
PayOrCanselPopup.propTypes = {
    cancelAction: PropTypes.func.isRequired,
    popupRef: PropTypes.object.isRequired,
};
export default PayOrCanselPopup;
